import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/bookings', label: 'Bookings' },
  { to: '/cross-check', label: 'Cross-check' },
  { to: '/stats', label: 'Statistics' },
  { to: '/users', label: 'Users' },
  { to: '/devices', label: 'Devices' },
  { to: '/etechlog', label: 'eTechlog Tracking' },
  { to: '/settings', label: 'Settings' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === 'admin';
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-cathay-700 text-white shadow">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-3">
          <div className="font-semibold tracking-wide">IPT Management App — Admin</div>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/profile" className="hover:underline opacity-90">{user?.display_name || user?.email}</Link>
            <button onClick={logout} className="bg-cathay-500 hover:bg-cathay-400 px-3 py-1 rounded transition">
              Sign out
            </button>
          </div>
        </div>
        <nav className="bg-cathay-800">
          <div className="max-w-7xl mx-auto px-4 flex gap-1 overflow-x-auto">
            {NAV.filter((n) => !n.adminOnly || isAdmin).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                className={({ isActive }) =>
                  'px-3 py-2 text-sm transition whitespace-nowrap ' +
                  (isActive
                    ? 'bg-cathay-700 text-white'
                    : 'text-cathay-100 hover:bg-cathay-700/60 hover:text-white')
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 py-6">{children}</main>
    </div>
  );
}
